export const BUSINESS_TYPES = {
  OTHERS: 15,
};
